import "../styles/institutes.css";
import { useState, useEffect } from "react";
import Footer from "../components/footer";
import location from "../assests/Images/location.svg";
import { Modal } from "react-bootstrap";
import { API_BASE_URL } from '../config/api';

import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
ModuleRegistry.registerModules([AllCommunityModule]);

const Courses = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [instituteQuery, setInstituteQuery] = useState("");
  const [showModal, setShowModal] = useState(false); // Changed from showOffcanvas
  const [isClosing, setIsClosing] = useState(false); // Add closing state for animation
  const [loading, setLoading] = useState(true); // Add loading state

  const [institues, setInstitues] = useState([]);
  const [currentCourseInstitutes, setCurrentCourseInstitutes] = useState([]);

const colDefs = [
    {
        headerName: "Action",
        field: "action",
        width: 100,
        cellRenderer: (params) => {
            return (
                <div
                    className="course-id"
                    onClick={() => handleShowModal(params)}
                    style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        minHeight: "40px", // Ensures enough height for vertical centering
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="none"
                            viewBox="0 0 24 24"
                            style={{ display: "block" }}
                        >
                            <path
                                d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                                stroke="#007bff"
                                strokeWidth="2"
                                fill="none"
                            />
                            <circle
                                cx="12"
                                cy="12"
                                r="3"
                                stroke="#007bff"
                                strokeWidth="2"
                                fill="none"
                            />
                        </svg>
                    </div>
                </div>
            );
        },
    },
    {
        headerName: "Course ID",
        field: "course_id",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        headerName: "Name",
        field: "name",
        filter: "agTextColumnFilter",
        width: 300,
    },
    {
        headerName: "Validity (Years)",
        field: "validity",
        filter: "agNumberColumnFilter",
        valueFormatter: (params) => {
            if (!params.value) {
                return "N/A";
            } else if (params.value === 1) {
                return `${params.value.toString()} Year`;
            } else {
                return `${params.value.toString()} Years`;
            }
        },
        width: 150,
    },
    {
        headerName: "Type",
        field: "type_verbose",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        headerName: "Duration",
        field: "duration",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        headerName: "Fee (₹)",
        field: "fee",
        filter: "agNumberColumnFilter",
        valueFormatter: (params) => {
            if (!params.value) {
                return "Null";
            } else {
                return `₹ ${params.value.toString()}`;
            }
        },
    },
    {
        headerName: "Is One-Time",
        field: "is_one_time",
        filter: "agTextColumnFilter",
        width: 100,
    },
    {
        headerName: "Level",
        field: "level",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        headerName: "Specific For",
        field: "specific_for",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        headerName: "Issue Mode",
        field: "issue_mode",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        headerName: "Status",
        field: "status",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        headerName: "Is Refresher",
        field: "is_refresher",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        headerName: "Is Affiliated",
        field: "is_affliated",
        filter: "agTextColumnFilter",
        width: 150,
    },
];

  useEffect(() => {
    const fetchInstitutes = async () => {
      try {
        setLoading(true); // Set loading to true before fetching
        const response = await fetch(
          `${API_BASE_URL}/api/learning/courses/`
        );
        const data = await response.json();
        setInstitues(data);
      } catch (error) {
        console.error("Error fetching Courses:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching (success or error)
      }
    };

    fetchInstitutes();
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleCloseModal();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const filteredInstitutes = currentCourseInstitutes.filter((institute) => {
    const query = instituteQuery.toLowerCase();
    return (
      institute.name?.toLowerCase().includes(query) ||
      institute.city?.toLowerCase().includes(query) ||
      institute.state?.toLowerCase().includes(query) ||
      institute.state_verbose?.toLowerCase().includes(query) ||
      institute.address?.toLowerCase().includes(query) ||
      institute.mti_no?.toString().toLowerCase().includes(query)
    );
  });

  const handleCloseModal = () => {
    setIsClosing(true);
    setInstituteQuery(""); // Clear the search query when closing the modal
    setTimeout(() => {
      setShowModal(false);
      setIsClosing(false);
    }, 300); // Match the CSS transition duration
  };

  const handleShowModal = (e) => {
    const index = e.data?.id - 1;
    setSelectedService(index);
    setCurrentCourseInstitutes(institues[index].course_institutes);
    setIsClosing(false);
    setShowModal(true);
  };

  const NextService = () => {
    if (selectedService < institues.length) {

      setSelectedService(selectedService + 1);
      setInstituteQuery("")
      setCurrentCourseInstitutes(
        institues[selectedService + 1].course_institutes
      );
    } else {
      console.log("index went out");
    }
  };

  const PrevServices = () => {
    if (selectedService !== 0) {
      setSelectedService(selectedService - 1);
      setInstituteQuery("");
      setCurrentCourseInstitutes(
        institues[selectedService - 1].course_institutes
      );
    } else {
      console.log("index went out");
    }
  };

  return (
    <div style={{ paddingTop: "100px" }}>
      <div className="institutes">
        <h1 className="section-title fs-2">Courses</h1>
        <p className="services-header-txt text-start">
          We provide comprehensive training courses tailored for both beginners
          and experienced seafarers, ensuring they acquire the essential skills
          and certifications for a successful maritime career.
        </p>
        <br />
        <div style={{ height: 500 }}>
          <AgGridReact
            rowData={institues}
            columnDefs={colDefs}
            pagination
            onRowDoubleClicked={handleShowModal}
            enableCellTextSelection={true}
            loading={loading}
            getRowStyle={(params) => {
              return {
                backgroundColor:
                  params.node.rowIndex % 2 === 0 ? "#ffffff" : "#f9f9f9",
              };
            }}
          />
        </div>
      </div>

      <Footer />

      {/* Modal Component */}
      <div className="model-comp">
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          centered
          className={`services-popup ${isClosing ? "closing" : ""}`}
          size="lg"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{institues[selectedService]?.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="course-detail-cont" className="offcanvas-body">
              <h6 className="offcanvas-subtitle">
                <b>Course Information</b>
              </h6>
              <div
                className="offcanvas-details"
                style={{ marginTop: "20px", marginBottom: "30px" }}
              >
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">Course ID</span>{" "}
                  <span className="color-gree">
                    {institues[selectedService]?.course_id}
                  </span>
                </p2>
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">Duration</span>{" "}
                  {institues[selectedService]?.duration}
                </p2>
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">
                    Is one Time course?
                  </span>{" "}
                  {institues[selectedService]?.is_one_time ? "Yes" : "No"}
                </p2>
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">Fee</span>{" "}
                  {institues[selectedService]?.fee}
                </p2>
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">Age Eligibility</span>{" "}
                  {institues[selectedService]?.age_eligibility}
                </p2>
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">
                    Education Eligibility
                  </span>{" "}
                  {institues[selectedService]?.education_eligibility}
                </p2>
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">
                    Other mandated Eligibility
                  </span>{" "}
                  {institues[selectedService]?.other_mandated_eligibility}
                </p2>
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">Issue mode</span>{" "}
                  {institues[selectedService]?.issue_mode}
                </p2>
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">
                    Is Refresher Course?
                  </span>{" "}
                  {institues[selectedService]?.is_refresher ? "Yes" : "No"}
                </p2>
                <p2 className="offcanvas-text">
                  <span className="offcanvas-table-head1">Is Affiliated?</span>{" "}
                  {institues[selectedService]?.is_affilated ? "Yes" : "No"}
                </p2>
              </div>
              <div>
                <h6 className="offcanvas-subtitle">
                  <b>List of Institutes</b>
                </h6>
                <input
                  type="text"
                  // className="form-control"
                  style={{ padding: "10px", marginTop: "20px",width:"100%",borderRadius:"8px",border:"1px solid grey" }}
                  value={instituteQuery}
                  onChange={(e) => {
                    setInstituteQuery(e.target.value);
                  }}
                  placeholder="Search for Institutes by Name, City, State, or MTI_NO"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  marginTop: "30px",
                }}
              >
                {filteredInstitutes.length > 0 ? (
                  filteredInstitutes.map((institute, index) => (
                    <div className="col" key={index}>
                      <div id="institue-card" className="h-100">
                        <div className="card-header">
                          <p className="card-text">
                            MTI_NO :{" "}
                            <span className="color-gree">
                              {institute.mti_no}
                            </span>
                          </p>
                        </div>
                        <div className="card-body">
                          <p className="card-title">{institute.name}</p>
                        </div>
                        <div className="card-footer">
                          <img
                            src={location}
                            alt="Location"
                            className="card-img-top"
                          />
                          <p5>
                            {institute.city}, {institute.state_verbose}
                          </p5>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-3">
                    <p className="text-muted">
                      No institutes found for this course.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="services-popup-footer">
            <div
              className="offcanvas-buttons"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <button className="canvas-next-button" onClick={PrevServices}>
                Back
              </button>
              <button
                className="canvas-next-button"
                onClick={NextService}
                disabled={selectedService + 1 === institues.length}
              >
                Next Course
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Courses;
